import React from 'react';
import type { MetricProviderId } from './types';
import { deviceMetricViews } from './views';
import { useDeviceMetricProvider } from './DeviceMetricProvider';

export default function DeviceMeasurementGuide({ provider, compact = false }: { provider?: MetricProviderId; compact?: boolean }) {
  const current = useDeviceMetricProvider();
  const Guide = deviceMetricViews[provider || current || 'fitbit'].Guide;
  return <Guide compact={compact} />;
}
